import React from 'react';
import { Save, RefreshCw } from 'lucide-react';

export const T = { vert: '#1e4a1a', or: '#c4a76c', textPrimary: '#1a1a1a', textSecondary: '#6b7280', textMuted: '#9ca3af', border: '#e8e5e0' };
export const CARD = { background: '#ffffff', border: `1px solid ${T.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
export const INPUT_CLS = "w-full px-4 py-3 rounded-xl text-sm outline-none transition-colors";
export const INPUT_STYLE = { background: '#f5f3ef', border: `1px solid ${T.border}`, color: T.textPrimary, fontFamily: "'Montserrat', sans-serif" };

export const CATEGORIES = [
  { value: 'aerial', label: 'Vue aérienne' }, { value: 'construction', label: 'Chantier' },
  { value: 'golf', label: 'Golf' }, { value: 'residential', label: 'Résidentiel' },
  { value: 'nature', label: 'Nature' }, { value: 'architecture', label: 'Architecture' },
  { value: 'interior', label: 'Intérieur' }, { value: 'lifestyle', label: 'Lifestyle' },
  { value: 'other', label: 'Autre' },
];

export const Field = ({ label, children }) => (
  <div>
    <label className="block text-[11px] font-medium uppercase tracking-wider mb-2" style={{ fontFamily: "'Montserrat', sans-serif", color: T.textMuted }}>{label}</label>
    {children}
  </div>
);

export const DarkInput = ({ value, onChange, placeholder, type = 'text', testId, rows }) => {
  const focusHandler = e => { e.target.style.borderColor = 'rgba(30,74,26,0.4)'; };
  const blurHandler = e => { e.target.style.borderColor = T.border; };
  if (rows) {
    return <textarea value={value} onChange={onChange} placeholder={placeholder} rows={rows} data-testid={testId} className={INPUT_CLS + ' resize-none'} style={INPUT_STYLE} onFocus={focusHandler} onBlur={blurHandler} />;
  }
  return <input type={type} value={value} onChange={onChange} placeholder={placeholder} data-testid={testId} className={INPUT_CLS} style={INPUT_STYLE} onFocus={focusHandler} onBlur={blurHandler} />;
};

export const GoldBtn = ({ onClick, disabled, children, testId }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testId}
    className="px-6 py-2.5 rounded-xl text-[13px] font-semibold transition-all flex items-center gap-2"
    style={{ background: disabled ? 'rgba(30,74,26,0.4)' : T.vert, color: '#ffffff', fontFamily: "'Montserrat', sans-serif" }}>
    {children}
  </button>
);

export const SaveBtn = ({ onClick, saving, testId, label = 'Enregistrer' }) => (
  <div className="flex justify-end">
    <GoldBtn onClick={onClick} disabled={saving} testId={testId}>
      {saving ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} {label}
    </GoldBtn>
  </div>
);
